<template>
  <div class="consult">
    <div class="colorCon"></div>
    <div class="backBtn" @click="gotoPage()">
        <img src="../assets/back.png" alt="">
        <span>星元资讯</span>
    </div>
    <div class="textCon">
        <div class="title">{{detail.title}}</div>
        <div class="publish_date">{{detail.publish_date}}</div>
        <div class="content" v-html="detail.content"></div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  data() {
    return{
      detail: {}
    }
  },
  mounted() {
    this.getDetail(this.$route.query.id);
  },
  methods: {
    gotoPage() {
      this.$router.go(-1);
    },
    getDetail(id) {
      $.ajax({
        type: "get",
        url: "/officialapi/articles/detail",
        async: true,
        data: {
          "id": id
        },
        success: (data) => {
          if (data["code"] == 0) {
            this.detail = data.data;
            document.title = "星元计划-" + this.detail.title;
          } else {
            this.$message.error(data.msg);
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.consult{
    position: relative;
    padding: 94px 0px 60px 0px;
    background: #F9FAFB;
    .colorCon{
        position: absolute;
        height: 180px;
        width: 100%;
        background: linear-gradient(180deg, #DAE6FF 0%, rgba(228, 237, 255, 0) 99%);
        top: 0;
        left: 0;
        z-index: 0;
    }
    .backBtn{
        position: absolute;
        cursor: pointer;
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: 500;
        line-height: 34px;
        display: flex;
        align-items: center;
        letter-spacing: normal;
        color: #666666;
        top: 20px;
        left: 32px;
        z-index: 999;
        img{
            width: 24px;
            height: 24px;
            margin-right: 5px;
        }
    }
    .textCon{
        width: 1200px;
        margin: 0 auto;
        border-radius: 10px;
        background: #FFFFFF;
        padding: 56px 54px 44px 54px;
        box-sizing: border-box;
        position: relative;
        z-index: 999;
    }
    .title{
        font-family: Source Han Sans;
        font-size: 30px;
        font-weight: bold;
        line-height: 34px;
        display: flex;
        align-items: center;
        letter-spacing: normal;
        color: #222222;
        margin-bottom: 12px;
    }
    .publish_date{
        font-family: Source Han Sans;
        font-size: 16px;
        font-weight: normal;
        line-height: 34px;
        display: flex;
        align-items: center;
        letter-spacing: normal;
        color: #666666;
        margin-bottom: 28px;
    }
    .content{
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: normal;
        line-height: 34px;
        letter-spacing: normal;
        color: #222222;
    }
}
</style>